import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
    DispatchCompleteLoadProduct,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";

export type HandlerType = Parameters<typeof DispatchCompleteLoadProduct>[0];

interface TransactionData {
    event: string;
    ecommerce: {
        currency: string;
        value: number;
        customer: string | undefined;
        items: { item_name: string; item_id: string; price?: number }[];
    };
}

addToChainAfter(chain, DispatchCompleteLoadProduct, SendProductViewTracking);

function SendProductViewTracking(props: HandlerType) {
    const state = props.getState();
    const { cartId } = state.pages.checkoutShipping;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);

    const billToState = getBillToState(state, cartState.value?.billToId);

    if (IS_SERVER_SIDE) {
        return;
    }

    const dataLayer = getDataLayer();
    if (!dataLayer || !props.product) {
        return;
    }

    const data: TransactionData = {
        event: "view_item",
        ecommerce: {
            currency: getCurrency(props.product.unitListPriceDisplay),
            value: 0,
            customer: billToState.value?.customerNumber,
            items: [
                {
                    item_id: props.product.productNumber,
                    item_name: props.product.productTitle,
                    price: props.product.unitListPrice,
                },
            ],
        },
    };

    dataLayer.push(data);
}

function getDataLayer() {
    return (window as any).dataLayer;
}

function getCurrency(priceString: string | undefined) {
    if (priceString?.includes("$")) {
        return "USD";
    }
    return "EUR";
}
